import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAnnouncement } from '@interfaces/announcement';
import { AppSharedModule } from '@modules/shared/app-shared.module';
import { TranslateInputValuePipe } from '@modules/shared/pipes/translate-input-value.pipe';
@Component({
  templateUrl: './announcement.component.html',
  imports: [AppSharedModule, TranslateInputValuePipe],
  standalone: true,
})
export class AnnouncementComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AnnouncementComponent>,
    @Inject(MAT_DIALOG_DATA) public input: IAnnouncement,
  ) {}

  ngOnInit(): void {}
}
